module.exports = __webpack_public_path__ + "img/u1253.77da34c5.png";